import React, { useState, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LINEAR_GRADIENT_BG, S3_URL, SHOP_SETTING_KEY } from "../../const";
import moment from "moment";
import { convertCurrency, numberFormat } from "../../helper";
import CustomButton from "../../components/CustomButton";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import { BsDatabaseFillAdd } from "react-icons/bs";
import { useMutation } from "@apollo/client";
import { CONFIRM_PURCHASE_ORDER } from "../../apollo/purchaseOrder/Mutation";
import { errorSwal, successSwal } from "../../helper/sweetalert";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import ComfirmModal from "../../components/ComfirmModal";

export default function PurchaseOrderListDetail() {
  const history = useHistory();
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const [purchaseOrder, setPurchaseOrder] = useState();
  const [showconfirmAddStock, setShowAddStock] = useState(false);
  const Location = useLocation();
  let componentRef = useRef();
  const shopSetting = useMemo(() => JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {}, []);

  // const [buychaseOrder, { loading: buychaseOrderLoading }] = useMutation(BUY_PURCHASE_ORDER);
  const [confirmPurchase, { loading: confirmPurchaseLoading }] = useMutation(CONFIRM_PURCHASE_ORDER);

  // Style definitions
  const tableHeaderStyle = {
    padding: '12px 8px',
    textAlign: 'center',
    backgroundColor: '#f5f7fa',
    color: '#4a5568',
    fontWeight: 600,
    borderBottom: '1px solid #e2e8f0',
    borderRight: '1px solid #e2e8f0',
    fontSize: '14px'
  };

  const tableCellStyle = {
    padding: '12px 8px',
    textAlign: 'center',
    borderBottom: '1px solid #e2e8f0',
    borderRight: '1px solid #e2e8f0',
    fontSize: '14px',
    color: '#4a5568',
    verticalAlign: 'middle'
  };

  const summaryRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    fontSize: '14px',
    color: '#4a5568'
  };

  const currencyStyle = (currency) => ({
    display: 'inline-block',
    padding: '2px 6px',
    borderRadius: '4px',
    backgroundColor: currency === 'USD' ? '#e6fffa' : currency === 'THB' ? '#ebf8ff' : '#f0fff4',
    color: currency === 'USD' ? '#2c7a7b' : currency === 'THB' ? '#2b6cb0' : '#2f855a',
    fontWeight: 500,
    fontSize: '13px'
  });

  // useEffect
  useEffect(() => {
    setPurchaseOrder(Location?.state?.state);
  }, [Location?.state?.state]);
  
  const handlePurchaseCompleted = async () => {
    try {
      if (confirmPurchaseLoading) return;
      const result = await confirmPurchase({
        variables: 
        {
          where: {
            id: purchaseOrder?.id
          },
          data: {
            paid: true,
            isSale: true,
            payment: purchaseOrder?.payment ?? "CASH",
            status: "COMPLETED",
            paySlip: []
          }
        }
      });
      const {status, msg} = JSON.parse(result?.data?.confirmPurchase);
      if (status) {
        successSwal(msg);
        history.goBack();
      } else {
        errorSwal(msg);
      }
    } catch (error) {
      errorSwal("sale error", error);
    }
  };
  return (
    <React.Fragment>
      <div className="purchaseorderlistdetail-main">
        <div className="purchaseorderlistdetail-header">
          <div>
            <BreadCrumbComponent
              goback={() => history.goBack()}
              txtFirst="ຂໍ້ມູນການສັ່ງຊື້"
              txtSecond={`ໃບບິນສັ່ງຊື້ສິນຄ້າ`}
            />
          </div>
        </div>
        <div className="purchaseorderlistdetail-content" style={{ fontFamily: '"Noto Sans Lao", sans-serif', maxWidth: '100%', padding: '20px' }}>
          <div className="purchaseorderlistdetail-A4" ref={componentRef} style={{ 
            backgroundColor: '#fff', 
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            padding: '30px',
            margin: '0 auto',
            maxWidth: '1000px'
          }}>
            <div style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: 600,
              marginBottom: "30px",
              color: '#2c3e50',
              borderBottom: '2px solid #f0f0f0',
              paddingBottom: '15px'
            }}>
              ໃບບິນສັ່ງຊື້ສິນຄ້າ
            </div>
            
            <div style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "30px",
              padding: "15px",
              backgroundColor: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                width: '100px',
                height: '100px',
                borderRadius: '8px',
                overflow: 'hidden',
                flexShrink: 0,
                border: '1px solid #e0e0e0',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img
                  src={shop?.image ? (S3_URL + shop.image) : "../../../assets/image/cficon.png"}
                  alt={shop?.name || 'Shop Logo'}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div style={{ 
                paddingLeft: "20px",
                lineHeight: '1.6',
                flexGrow: 1
              }}>
                <div style={{ 
                  fontSize: '18px',
                  fontWeight: 600,
                  color: '#2c3e50',
                  marginBottom: '5px'
                }}>
                  {shop?.name || 'N/A'}
                </div>
                <div style={{ color: '#555', marginBottom: '5px' }}>
                  <i className="fas fa-map-marker-alt" style={{ marginRight: '8px' }}></i>
                  {shop?.address ? `${shop.address.village || ''} ${shop.address.district ? `, ${shop.address.district}` : ''}${shop.address.province ? `, ${shop.address.province}` : ''}` : 'N/A'}
                </div>
                {shop?.phone && (
                  <div style={{ color: '#555' }}>
                    <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                    {shop.phone}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              margin: "20px 0",
              borderRadius: '6px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                width: "50%",
                textAlign: "center",
                padding: '12px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e0e0e0',
                fontWeight: 500,
                color: '#555'
              }}>
                ເລກທີບິນ: <span style={{ color: '#2c3e50', fontWeight: 600 }}>{Location?.state?.state?.code || 'N/A'}</span>
              </div>
              <div style={{
                width: "50%",
                textAlign: "center",
                padding: '12px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e0e0e0',
                borderLeft: 'none',
                fontWeight: 500,
                color: '#555'
              }}>
                ວັນທີ: <span style={{ color: '#2c3e50', fontWeight: 600 }}>
                  {purchaseOrder?.createdAt ? moment(purchaseOrder.createdAt).format("DD/MM/YYYY HH:mm") : 'N/A'}
                </span>
              </div>
            </div>

            <div style={{ margin: '30px 0' }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: `50px 1.5fr 80px 120px 120px 80px${shopSetting?.stockInOut ? ' 100px 100px' : ''}`,
                width: '100%',
                overflowX: 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}>
                {/* Table Header */}
                <div style={tableHeaderStyle}>
                  ລ/ດ
                </div>
                <div style={tableHeaderStyle}>
                  ຊື່ສິນຄ້າ
                </div>
                <div style={tableHeaderStyle}>
                  ຈຳນວນ
                </div>
                <div style={tableHeaderStyle}>
                  ລາຄາ
                </div>
                <div style={tableHeaderStyle}>
                  ລວມລາຄາ
                </div>
                <div style={tableHeaderStyle}>
                  ສະກຸນເງີນ
                </div>
                {shopSetting?.stockInOut && (
                  <>
                    <div style={tableHeaderStyle}>
                      ຜະລິດ
                    </div>
                    <div style={tableHeaderStyle}>
                      ຫມົດອາຍຸ
                    </div>
                  </>
                )}
                {purchaseOrder?.purchaseorders?.map((purchaseorder, index) => (
                  <React.Fragment key={index}>
                    <div style={tableCellStyle}>
                      {index + 1}
                    </div>
                    <div style={{ ...tableCellStyle, textAlign: 'left', padding: '12px 15px' }}>
                      <div style={{ fontWeight: 500, marginBottom: '4px' }}>{purchaseorder?.productName || 'N/A'}</div>
                      {purchaseorder?.barcode && (
                        <div style={{ fontSize: '12px', color: '#666' }}>Barcode: {purchaseorder.barcode}</div>
                      )}
                    </div>
                    <div style={tableCellStyle}>
                      {purchaseorder?.amount || '0'}
                    </div>
                    <div style={tableCellStyle}>
                      {purchaseorder?.stock?.originPrice
                        ? numberFormat(purchaseorder.stock.originPrice)
                        : "-"}
                    </div>
                    <div style={{ ...tableCellStyle, fontWeight: 600, color: '#2c3e50' }}>
                      {numberFormat(purchaseorder?.totalPrice || 0)}
                    </div>
                    <div style={tableCellStyle}>
                      <span style={currencyStyle(purchaseorder?.currency)}>
                        {convertCurrency(purchaseorder?.currency || 'LAK')}
                      </span>
                    </div>
                    {shopSetting?.stockInOut && (
                      <>
                        <div style={tableCellStyle}>
                          {purchaseorder?.mfg ? moment(purchaseorder.mfg).format("DD/MM/YYYY") : 'N/A'}
                        </div>
                        <div style={tableCellStyle}>
                          {purchaseorder?.exp ? moment(purchaseorder.exp).format("DD/MM/YYYY") : 'N/A'}
                        </div>
                      </>
                    )}
                  </React.Fragment>
                ))}
                                {/* Total Summary */}
                <div style={{
                  gridColumn: '1 / -1',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '15px 15px',
                  marginTop: '20px',
                  borderTop: '1px solid #e0e0e0'
                }}>
                  <div style={{ width: '350px' }}>
                    <div style={summaryRowStyle}>
                      <span>ຍອດລວມກີບ:</span>
                      <span style={{ fontWeight: 600 }}>{numberFormat(purchaseOrder?.totalPrice ?? 0)} ₭</span>
                    </div>
                    <div style={summaryRowStyle}>
                      <span>ຍອດລວມບາດ:</span>
                      <span style={{ fontWeight: 600 }}>{numberFormat(purchaseOrder?.sumPriceBaht ?? 0)} ฿</span>
                    </div>
                    <div style={summaryRowStyle}>
                      <span>ຍອດລວມໂດລາ:</span>
                      <span style={{ fontWeight: 600 }}>{numberFormat(purchaseOrder?.sumPriceUsd ?? 0)} $</span>
                    </div>
                    <div style={{
                      ...summaryRowStyle,
                      marginTop: '10px',
                      paddingTop: '10px',
                      borderTop: '1px solid #e0e0e0',
                      fontSize: '16px',
                      color: '#2c3e50'
                    }}>
                      <span>ລາຄາລວມທັງໝົດ:</span>
                      <span style={{ fontWeight: 700, fontSize: '18px' }}>
                        {numberFormat(purchaseOrder?.sumPrice ?? 0)} ₭
                      </span>
                    </div>
                  </div>
                </div>
                <div></div>
                <div></div>
                <div></div>

                {/* lyzen */}
              </div>

                              {/* Signatures */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '60px',
                  paddingTop: '20px',
                  borderTop: '1px solid #e0e0e0'
                }}>
                  <div style={{ textAlign: 'center', width: '45%' }}>
                    <div style={{
                      height: '1px',
                      borderBottom: '1px dashed #999',
                      margin: '0 auto 10px',
                      width: '80%'
                    }}></div>
                    <div style={{ fontSize: '15px', fontWeight: 600, color: '#555' }}>ຜູ້ຈັດຊື້</div>
                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px' }}>
                      (ລົງນາມ/ຕົວຢ່າງ)
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', width: '45%' }}>
                    <div style={{
                      height: '1px',
                      borderBottom: '1px dashed #999',
                      margin: '0 auto 10px',
                      width: '80%'
                    }}></div>
                    <div style={{ fontSize: '15px', fontWeight: 600, color: '#555' }}>ຜູ້ອະນຸມັດ</div>
                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px' }}>
                      (ລົງນາມ/ຕົວຢ່າງ)
                    </div>
                  </div>
                </div>
            </div>
          </div>

          {/* button */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
          }}>
          <div
            style={{
              display: "flex",
              gap: 20,
              justifyContent: "center",
              alignItems: "center",
            }}>
            <CustomButton
              width={140}
              height={42}
              borderRadius={4}
              background={LINEAR_GRADIENT_BG}
              color="#fff"
              border="1px solid #3C169B "
              fontweight={400}
              title={"ກັບຄືນ"}
              onClick={() => history.goBack()}
            />
            <ReactToPrint
              trigger={() => (
                <CustomButton
                  title=" ພິມບິນ"
                  icon={<PrintIcon />}
                  width={140}
                  height={42}
                  borderRadius={4}
                  background="green"
                />
              )}
              content={() => componentRef.current}
            />
            <CustomButton
              width={140}
              height={42}
              background={LINEAR_GRADIENT_BG}
              borderRadius={4}
              icon={<BsDatabaseFillAdd size={20} />}
              title={"ນຳເຂົ້າສະຕ໋ອກ"}
              onClick={() => setShowAddStock(true)}
            />
          </div>
        </div>
      </div> 

      <ComfirmModal
        showConfirmModal={showconfirmAddStock}
        handleCancel={() => setShowAddStock(false)}
        // handleConfirm={_BuyPurchaseOrder}
        handleConfirm={handlePurchaseCompleted}
        title="ແຈ້ງເຕືອນ"
        // loadingConfirm={buychaseOrderLoading}
        text={"ທ່ານຕອ້ງການເພີ່ມສິນຄ້າທັງໝົດນີ້ເຂົ້າສະຕ໋ອກ ຫຼື ບໍ່ "}
      />
    </React.Fragment>
  );
}
